import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import * as signalR from "@microsoft/signalr";
import { useSelector } from "react-redux";
import { useCallback } from "react";

const hubUrl = process.env.REACT_APP_API_URL;

const SignalRContext = createContext(null);

export const SignalRProvider = ({ children }) => {
  const connectionRef = useRef(null);
  const [isConnected, setIsConnected] = useState(false);
  const user = useSelector((state) => state.user);

  const token = localStorage.getItem("authToken");

  useEffect(() => {


    if (!user.userProfile?.userID) {
      return;
    }

    const connect = async () => {
      if (!connectionRef.current) {
        connectionRef.current = new signalR.HubConnectionBuilder()
          .withUrl(`${hubUrl}/notificationsHub?userId=${user.userProfile?.userID}&role=${user.role}`)
          .withAutomaticReconnect()
          .build();

        connectionRef.current.on("notification", (message) => {
          console.log("📩 Notification from server:", message);
        });

        connectionRef.current.onreconnected(() => setIsConnected(true));
        connectionRef.current.onclose(() => setIsConnected(false));
      }

      if (connectionRef.current.state !== signalR.HubConnectionState.Connected) {
        try {
          await connectionRef.current.start();
          setIsConnected(true);
        } catch (error) {
          console.error("SignalR Connection Error:", error);
          setTimeout(connect, 2000);
        }
      }
    };

    connect();

    return () => {
      connectionRef.current?.stop();
    };

  }, [user.userProfile?.userID]);

  // const subscribe = (method, callback) => {
  //   connectionRef.current?.on(method, callback);

  //   return () => {
  //     connectionRef.current?.off(method, callback);
  //   };
  // };

  const subscribe = useCallback((method, callback) => {
    connectionRef.current?.on(method, callback);

    return () => {
      connectionRef.current?.off(method, callback);
    };
  }, []);

  const send = async (method, ...args) => {
    await connectionRef.current?.invoke(method, ...args);
  };

  return (
    <SignalRContext.Provider value={{ hubConnection: connectionRef.current, isConnected, subscribe, send }}>
      {children}
    </SignalRContext.Provider>
  );
};

export const useSignalR = () => useContext(SignalRContext);
